import { useState } from "react";

import "../../shared/style/typography.scss";
import "../../shared/style/colors.scss";

import Button from "../UserInput/Buttons/Button";
import BulkGeneratorDialog from "components/Dialogs/BulkGeneratorDialog";

/**
 *
 * @param {object} props
 * @param {(link: object) => void} props.onBulkLinksGenerated Callback function to handle link generation
 */
const BulkLinkGenerator = ({ collectors, onBulkLinksGenerated }) => {
    const [isBulkGenerateLinkModalOpen, setIsBulkGenerateLinkModalOpen] = useState(false);

    function closeBulkGenerateLinkModal() {
        setIsBulkGenerateLinkModalOpen(false);
    }

    return (
        <>
            <div>
                <div>
                    <Button
                        size="xs"
                        handleOnClick={() => {
                            setIsBulkGenerateLinkModalOpen(true);
                        }}
                    >
                        New Upload
                    </Button>
                </div>
            </div>
            <BulkGeneratorDialog
                title="Bulk generate links"
                isOpen={isBulkGenerateLinkModalOpen}
                onUploadCreated={(createdUpload) => {
                    onBulkLinksGenerated(createdUpload);
                }}
                onClose={closeBulkGenerateLinkModal}
                collectors={collectors}
            />
        </>
    );
};

export default BulkLinkGenerator;
